// extracted by css-extract-rspack-plugin
var _1 = "SaG4kOAtCJ01xlbC";
var _2 = "HkLMhhu1KHYbxQA_";
export { _1 as "headerStyle", _2 as "modalHeaderWrapperStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "SaG4kOAtCJ01xlbC";
var _2 = "HkLMhhu1KHYbxQA_";
export { _1 as "headerStyle", _2 as "modalHeaderWrapperStyle" }
